import { jsx } from "panel";
import { CustomBucketSubitem } from "common/query-builder/query-entry-section/components/custom-bucket-subitem";
import { TypecastSubitem } from "common/query-builder/query-entry-section/components/typecast-subitem";
import { Action, EntryPart } from "common/query-builder/query-entry-section/types";
import {
  isListOfObjectsSegment,
  isSegmentation
} from "common/query-builder/query-block/segment-menu/types";
import { QueryReason } from "common/report/util/query-tracking/types";
import { isEventBasedBehavioralSegmentation } from "common/query-builder/query-entry-section/row-types/behavior/utils";
import { BaseEntryRowEl } from "../base/template";
import { populateListPropertyAttrs } from "../row-util";
import {
  BehavioralSubFilters,
  BehavioralSubItem,
  MultiAttributionBehaviorFilterSubItem,
  MultiAttributionLookbackSubItem,
  PropertySelector
} from "../behavior/template";
import { SegmentListObjectPropertySelector } from "./components/segment-list-object-property-selector";
export function SegmentEntryRowEl({ section, entry, index }) {
  const handlePropertySelect = (selection, queryReason) => {
    if (isSegmentation(selection)) {
      populateListPropertyAttrs(selection);
      if (isListOfObjectsSegment(selection)) {
        section.setActiveEntry(index, EntryPart.SubValue);
      }
    }
    if (isEventBasedBehavioralSegmentation(selection) && !selection.behavior.event.value) {
      section.setActiveEntry(index, selection.behavior.aggregationOperator ? EntryPart.SubValue : EntryPart.Aggregator);
    }
    this.triggerUpdate(Action.Edit, selection, queryReason);
  };
  const selectorRenderer = () => /* @__PURE__ */ jsx(PropertySelector, {
    entry: this.entry,
    handleSelect: handlePropertySelect,
    index: this.index,
    isPlaceholder: this.isPlaceholder(),
    section: this.section,
    selected: this.entry.event
  });
  const bodyRowRenderer = () => {
    var _a;
    const segment = this.entry.event;
    return /* @__PURE__ */ jsx(null, null, isListOfObjectsSegment(segment) && /* @__PURE__ */ jsx(SegmentListObjectPropertySelector, {
      segment,
      entryRowIdx: index,
      section,
      handleSelect: this.handleListObjectPropertySelect
    }), isEventBasedBehavioralSegmentation(segment) && ((_a = this.entry.event) == null ? void 0 : _a[`behavior`]) && /* @__PURE__ */ jsx(BehavioralSubItem, {
      entry: this.entry,
      selected: segment,
      handleSelect: handlePropertySelect,
      index: this.index,
      isPlaceholder: this.isPlaceholder(),
      section: this.section
    }), /* @__PURE__ */ jsx(MultiAttributionLookbackSubItem, {
      section,
      selected: segment,
      index: this.index,
      handleSelect: handlePropertySelect
    }), /* @__PURE__ */ jsx(MultiAttributionBehaviorFilterSubItem, {
      section,
      selected: segment,
      index: this.index,
      handleSelect: handlePropertySelect
    }), /* @__PURE__ */ jsx(CustomBucketSubitem, {
      section,
      index
    }), /* @__PURE__ */ jsx(TypecastSubitem, {
      value: this.entry.event,
      onTypeChange: (segment2) => handlePropertySelect(segment2, QueryReason.QbBreakdownUpdate)
    }));
  };
  const suffixRenderer = () => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(BehavioralSubFilters, {
    entry: this.entry,
    handleSelect: handlePropertySelect,
    index: this.index,
    section: this.section,
    selected: this.entry.event
  }));
  return /* @__PURE__ */ jsx(BaseEntryRowEl, {
    index,
    el: section,
    entry,
    rowRenderer: { selectorRenderer, suffixRenderer, bodyRowRenderer },
    isPlaceholder: this.isPlaceholder(),
    rowIcon: this.selectorIcon()
  });
}
